import { get, post, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/emails`;
export const listEmails      = (wsId, params = {}) => { const q = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : ''; return get(`${base(wsId)}${q}`); };
export const createEmail     = (wsId, body)        => post(base(wsId), body);
export const getEmail        = (wsId, emailId)     => get(`${base(wsId)}/${emailId}`);
export const removeEmail     = (wsId, emailId)     => del(`${base(wsId)}/${emailId}`);
export const getThread       = (wsId, threadId)    => get(`${base(wsId)}/thread/${threadId}`);
export const getMetrics      = (wsId)              => get(`${base(wsId)}/metrics`);
export const listTemplates   = (wsId)              => get(`${base(wsId)}/templates`);
export const createTemplate  = (wsId, body)        => post(`${base(wsId)}/templates`, body);
export const removeTemplate  = (wsId, id)          => del(`${base(wsId)}/templates/${id}`);

const _emailType = (t) => {
  if (t === 'INCOMING') { return 'received'; }
  if (t === 'DRAFT')    { return 'draft'; }
  return 'sent';
};

const _relTime = (iso) => {
  if (!iso) return 'just now';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000)     return 'just now';
  if (ms < 3600000)   return Math.floor(ms / 60000) + 'm ago';
  if (ms < 86400000)  return Math.floor(ms / 3600000) + 'h ago';
  if (ms < 172800000) return 'yesterday';
  return new Date(iso).toLocaleDateString('en-IN');
};

export const normEmail = (e) => ({
  id:        e.id,
  subject:   e.subject   || '',
  fromName:  e.fromName  || e.fromEmail || 'Unknown',
  fromEmail: e.fromEmail || '',
  to:        Array.isArray(e.toEmails) && e.toEmails.length ? e.toEmails[0] : '',
  toEmails:  e.toEmails  || [],
  ccEmails:  e.ccEmails  || [],
  body:      e.body      || '',
  type:      _emailType(e.type),
  status:    (e.status   || 'SENT').toLowerCase(),
  time:      _relTime(e.sentAt || e.createdAt),
  sentAt:    e.sentAt    || null,
  createdAt: e.createdAt || null,
  threadId:  e.threadId  || null,
  personId:  e.personId  || null,
  companyId: e.companyId || null,
  dealId:    e.dealId    || null,
});
